import React from 'react';
import { Search, X } from 'lucide-react';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const SearchField: React.FC<SearchFieldProps> = ({ value, onChange, placeholder }) => (
  <div className="relative">
    <input
      type="text"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      className="w-full rounded-2xl border border-white/10 bg-[#120807] px-4 py-3 pl-12 text-white placeholder:text-white/35 focus:border-amber-400/35 focus:outline-none"
    />
    <Search className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-white/35" />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 text-white/45 transition hover:bg-white/10 hover:text-white"
      >
        <X className="h-4 w-4" />
      </button>
    )}
  </div>
);

export default SearchField;

